/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Packing_SlipInputs */

const vi_print_packing_slip = /** @type {(inputs: Print_Packing_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu đóng gói`)
};

/**

* @param {Print_Packing_SlipInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_packing_slip = /** @type {((inputs?: Print_Packing_SlipInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Packing_SlipInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_packing_slip(inputs)
});